import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import NudgesContainer from "@/app/components/ui/Nudges/NudgesContainer";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { ICustomerEMRState } from "@/app_redux/reducers/slices/auth/customer_emr_slice";
import { setIsEmrComplete } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

import { useState } from "react";
interface IEMRSubmissionModalState {
  handleSubmit: (submitAsDraft: boolean) => void;
}
const EMRSubmissionModal = () => {
  const { handleSubmit } = useModalState("EMR_SUBMISSION_MODAL") as IEMRSubmissionModalState;
  const { setInvisible } = useModalActions("EMR_SUBMISSION_MODAL");

  const { getRouteKey } = useRouter();
  const { activeEMRId } = useRouteInfo(getRouteKey("CUSTOMER_EMR", "id")).routeState.state as ICustomerEMRState;
  const [loader, setLoader] = useState(false);
  const isEmrUpdate = useLoader("isEMRUpdateInProgress");
  const dispatch = useAppDispatch();

  const alert_category_list = ["Dr Reminder"]

  return (
    <ModalPrompt
      modalId="EMR_SUBMISSION_MODAL"
      backdropBlur={false}
      contentOverflow
      dialogClassName="w-2xl"
      button={{
        primaryButtonDisabled: isEmrUpdate,
        primaryCallback: () => {
          setLoader(true);
          dispatch(setIsEmrComplete({ status: true }));
          handleSubmit(false);
          // setInvisible();
          // setLoader(false);
        },
        secondaryCallback: () => {
          setLoader(false);
          setInvisible();
        },
        primaryButtonClassname: "bg-blue-500 text-xs",
        secondaryButtonText: "Let Me Check",
        secondaryButtonClassname: "text-xs",
        primaryButtonText: `${isEmrUpdate ? "Loading...." : loader ? "Loading...." : "Submit EMR"}`,
        
      }}
      title={<span>Are you sure ?</span>}
      content={
        <div className="w-[600px]"> 
         <div className="text-xs">
          Are you sure you want to submit the EMR, this will mark the EMR as{" "}
          <strong className="text-green-500">Completed</strong> from <strong className="text-yellow-500">Draft</strong>{" "}
          state. That cannot be edited later.{" "}
        </div>
        <div className="py-3 pr-4">
          <NudgesContainer
            source="EMR"
            ermid={activeEMRId}
            alert_category_list={alert_category_list}
            
          />
          </div>
        </div>
      }
    />
  );
};

export default EMRSubmissionModal;
